export const TYPE_CHOICES = [
  {
    type: 'customer',
    title: 'خریدار',
    description: 'برای خرید کالا از فروشگاه‌های چارسوق.',
    icon: 'fa-shopping-basket',
  },
  {
    type: 'vendor',
    title: 'فروشنده',
    description: 'فروشگاه خود را در چارسوق معرفی کنید.',
    icon: 'fa-store',
  },
  {
    type: 'factory',
    title: 'کارخانه / تولیدکننده مستقیم',
    description: 'محصولات خود را مستقیم عرضه کنید.',
    icon: 'fa-industry',
  },
  {
    type: 'company',
    title: 'شرکت',
    description: 'برای خرید و مدیریت سازمانی ثبت‌نام کنید.',
    icon: 'fa-building',
  },
];

export const SIGNUP_TYPES = new Set(TYPE_CHOICES.map(({ type }) => type));

export default function SignupTypePicker({ choices, onSelect }) {
  return (
    <section className="signup-type-picker" aria-labelledby="signup-type-heading">
      <h2 id="signup-type-heading">نوع حساب خود را انتخاب کنید</h2>
      <p className="signup-picker-subtitle">برای شروع، گزینهٔ مناسب خود را انتخاب کنید.</p>
      <div className="signup-type-list">
        {choices.map((choice) => (
          <button
            key={choice.type}
            type="button"
            className="signup-type-card"
            onClick={() => onSelect(choice.type)}
          >
            <span className="signup-type-card-icon" aria-hidden="true">
              <i className={`fas ${choice.icon}`} />
            </span>
            <span className="signup-type-card-content">
              <span className="signup-type-card-title">{choice.title}</span>
              <span className="signup-type-card-description">{choice.description}</span>
            </span>
            <span className="signup-type-card-chevron" aria-hidden="true">
              <i className="fas fa-chevron-left" />
            </span>
          </button>
        ))}
      </div>
    </section>
  );
}
